import React, { cloneElement } from "react";
import {
  Datagrid,
  Filter,
  TextField,
  SearchInput,
  Button,
  sanitizeListRestProps,
  TopToolbar,
  useListContext,
  ResourceContextProvider,
  ShowProps,
  RowClickFunction,
  FunctionField,
} from "react-admin";
import IconPlus from "@material-ui/icons/Add";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import SubcontractorRateChart from "../subcontractorRateCharts/SubcontractorRateChartsShow";
import {
  subcontractorHolidayPaymentMonthList,
  subcontractorHolidayPaymentPricingTypeList,
} from "pages/subcontractorHolidayPayments/const";
import SubcontractorHolidayPaymentTermPeriodField from "./components/SubcontractorHolidayPaymentTermPeriodField";
import { PaddingDenseStyled2List } from "../../components/ListWrapper";
import CustomPagination from "../../components/CustomPagination";

const SubcontractorHolidayPaymentFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
  </Filter>
);

const ListActions = (props: any) => {
  const { className, exporter, filters, maxResults, history, ...rest } = props;
  const { resource, displayedFilters, filterValues, showFilter } =
    useListContext();

  let actionUrl = "";
  let buttonLabel = "";

  actionUrl = `/subcontractorHolidayPayments/create?source=${JSON.stringify({
    schoolId: Number(props.filterValues?.SchoolId),
  })}&schoolId=${Number(props.filterValues?.SchoolId)}`;
  buttonLabel = "Add Subcontractor Holiday Payment";

  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: "button",
        })}

      <Button onClick={() => history.push(actionUrl)} label={buttonLabel}>
        <IconPlus />
      </Button>
    </TopToolbar>
  );
};

const SubcontractorPricing = (props: ShowProps) => {
  const rowClick: RowClickFunction = (id, basePath, record) =>
    `/subcontractorHolidayPayments/${id}/edit?schoolId=${Number(
      record.schoolId,
    )}`;

  const monthFormatter = (id: string, source: any): string => {
    const item = source.find((type: any) => type.id === id);
    return item ? item.name : "-";
  };

  const pricingTypeFormatter = (id: string, source: any): string => {
    const item = source.find((type: any) => type.id === id);
    return item ? item.name : "-";
  };

  return (
    <SanitizedGrid container spacing={2}>
      <Grid item xs={12}>
        <SubcontractorRateChart {...props} />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h6">Subcontractor Holiday Payment</Typography>
      </Grid>
      <Grid item xs={12}>
        <ResourceContextProvider value="subcontractorHolidayPayments">
          <PaddingDenseStyled2List
            exporter={false}
            hasCreate={false}
            filters={<SubcontractorHolidayPaymentFilter />}
            filterDefaultValues={{ SchoolId: Number(props.id) }}
            bulkActionButtons={false}
            actions={<ListActions history={props.history} />}
            title=" "
            pagination={<CustomPagination />}
            {...props}
          >
            <Datagrid rowClick={rowClick}>
              <TextField source="id" />
              <TextField source="name" label="Name" />
              <FunctionField
                label="Term Period"
                render={(record: any) => (
                  <SubcontractorHolidayPaymentTermPeriodField
                    routeType={record.routeType}
                  />
                )}
              />
              <TextField source="routeType" label="Route Type" />
              <FunctionField
                label="Holiday Period Month"
                render={(props: any) =>
                  monthFormatter(
                    props.holidayPeriodMonth,
                    subcontractorHolidayPaymentMonthList,
                  )
                }
              />
              <TextField
                source="holidayPeriodYear"
                label="Holiday Period Year"
              />
              <FunctionField
                label="Pricing Type"
                render={(props: any) =>
                  pricingTypeFormatter(
                    props.pricingType,
                    subcontractorHolidayPaymentPricingTypeList,
                  )
                }
              />
            </Datagrid>
          </PaddingDenseStyled2List>
        </ResourceContextProvider>
      </Grid>
    </SanitizedGrid>
  );
};

export default SubcontractorPricing;
